import { render, staticRenderFns } from "./ListSkeleton.vue?vue&type=template&id=acefd6bc&"
import script from "./ListSkeleton.vue?vue&type=script&lang=js&"
export * from "./ListSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports